import React from 'react';
import { connect } from 'react-redux';
import { logReaderManagerEvents, sendReaderManagerLogsToS3 } from './ReaderManagerEvents/ReaderManagerSlice';
import { logSentryException } from '../../services/util';
import { ErrorModal, getErrorModalTypes } from './ErrorModal';

class ReaderManagerErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    console.log("ReaderManagerErrorBoundary", props)
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.props.logReaderManagerEvents({type: "ReaderManagerErrorBoundary", error: error?.message, errorInfo})
    this.props.sendReaderManagerLogsToS3();
    logSentryException(error);

    try{
      this.props.openModal(<ErrorModal
          type={getErrorModalTypes().ERROR}
          speech={this.props.speech}
        />)
    }catch(e){
      console.log("Error in ReaderManagerErrorBoundary: ", e);
      logSentryException(e);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return null;
    }

    return this.props.children; 
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  logReaderManagerEvents,
  sendReaderManagerLogsToS3,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReaderManagerErrorBoundary);